import { useEffect, useState } from "react";

const INTERACTION_EVENTS = [
  "scroll",
  "pointerdown",
  "keydown",
  "touchstart",
] as const;

export function useDeferredThirdParty(timeoutMs = 4000, enabled = true) {
  const [shouldLoad, setShouldLoad] = useState(false);

  useEffect(() => {
    if (!enabled || shouldLoad) return;

    let idleId: number | undefined;
    let timeoutId: ReturnType<typeof setTimeout> | undefined;
    let loaded = false;

    const load = () => {
      if (loaded) return;
      loaded = true;
      setShouldLoad(true);
      cleanup();
    };

    const cleanup = () => {
      INTERACTION_EVENTS.forEach((event) =>
        window.removeEventListener(event, load)
      );

      const canCancelIdleCallback = "cancelIdleCallback" in window;
      if (idleId != null && canCancelIdleCallback)
        window.cancelIdleCallback(idleId);

      if (timeoutId != null) clearTimeout(timeoutId);
    };

    INTERACTION_EVENTS.forEach((event) =>
      window.addEventListener(event, load, { once: true, passive: true })
    );

    const supportsIdleCallback = "requestIdleCallback" in window;
    if (supportsIdleCallback)
      idleId = window.requestIdleCallback(load, { timeout: timeoutMs });
    else timeoutId = setTimeout(load, timeoutMs);

    return cleanup;
  }, [enabled, shouldLoad, timeoutMs]);

  return shouldLoad;
}
